import Card from "./Card.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default function TeaserCard(props) {
  props = useThemeProps({ props, name: "TeaserCard" });
  let { color = "transparent", mediaColspan = 2, ...restProps } = props;
  return (
    <Card
      color={color}
      mediaColspan={mediaColspan}
      forceHorizontal={true}
      {...restProps}
    />
  );
}
